
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/submit-job-postings",
      function () {
        return require("private-next-pages/submit-job-postings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/submit-job-postings"])
      });
    }
  